export default __webpack_public_path__ + "static/media/my-near-wallet-icon.21577bc8.png";